import type { ComponentProps } from 'react';

import { TagField as UadTagField } from '@iconik-io/uad';

import { useFieldContext } from '../app_form_context';
import { getFieldErrorMessage } from '../get_field_error_message';

type UadTagFieldProps = ComponentProps<typeof UadTagField>;

export type TagFieldProps = Omit<
  UadTagFieldProps,
  'name' | 'value' | 'defaultValue' | 'onChange' | 'isInvalid' | 'errorMessage'
>;

export function TagField(props: TagFieldProps) {
  const field = useFieldContext<string[]>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <UadTagField
      name={field.name}
      value={field.state.value}
      onChange={(keys) => {
        field.setValue(keys.map(String));
      }}
      isInvalid={isInvalid}
      errorMessage={
        isInvalid ? getFieldErrorMessage(field.state.meta.errors) : undefined
      }
      {...props}
    />
  );
}
